module.exports = __webpack_public_path__ + "static/media/bread-emoji.7a5b4386.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/bread-emoji.png
// module id = 9
// module chunks = 0